import React, { useState, useEffect } from 'react'

import { Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import ArticlesOfIncorporation from './ArticleOfIncorporation';
import DutiesOfTheBoard from './DutiesOfTheBoard';
import BoardOfDirectors from './BoardOfDirectors';
import HistoryOfSanPedro from './HistoryOfSanPedro';


function Divider({ title, theme, id, isMobile }) {
  return (
    <div id={id} className='about-us-divider' style={{
      "--w": isMobile ? "10vw" : "50vw",
      "--c": theme.palette.secondary.main,
      "--b": "4px",
      "--g": isMobile ? "12px" : "40px",
      "--p": isMobile ? "1em" : "3em"
    }}>
      <Typography variant="h4" style={{
        color: theme.palette.secondary.contrastText,
        fontFamily: "'Cinzel', serif",
        fontWeight: 700
      }}>
        {title}
      </Typography>
    </div>
  )
}

export default function AboutUsPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 20,
      paddingLeft: isMobile ? 8 : 20,
      paddingRight: isMobile ? 8 : 20,
      gap: 20,
      paddingBottom: 20,
    }}>
      <div style={{ width: "100%", maxWidth: 1300 }}>
      <Divider title="Board of Directors 2026" theme={theme} id="board-of-directors" isMobile={isMobile} />
      <BoardOfDirectors />
      <Divider title="History of San Pedro" theme={theme} id="history-of-san-pedro" isMobile={isMobile} />
      <HistoryOfSanPedro />
      <Divider title="Articles of Incorporation" theme={theme} id="articles-of-incorporation" isMobile={isMobile} />
      <ArticlesOfIncorporation />
      <Divider title="Duties of the Board" theme={theme} id="duties-of-the-board" isMobile={isMobile} />
      <DutiesOfTheBoard />
    </div>
    </div>
  )
}